import React, { useState } from 'react';

import { useApplicationStore } from '../../contexts';
import { withAuthRedirect } from '../hocs';
import { Panel, PanelHeader, PanelContent } from '../atoms';
import { ApplicationsFilter, ApplicationsList } from '../organisms';

const ApplicationsPage = () => {
  const loading = useApplicationStore((s) => s.isLoading);
  const applications = useApplicationStore((s) => s.applications);
  const [nonce, setNonce] = useState(1);

  return (
    <Panel>
      <PanelHeader>
        <h1>Applications</h1>
        <ApplicationsFilter
          // used to trigger a reload
          nonce={nonce}
          filter={{
            applicationStep: [
              'NEW - Entered',
              'Pending Approval',
              'Approved',
              'Signed',
              'Rejected',
              'Payment Assist - Refer',
              'Pending ID'
            ]
          }}
        />
      </PanelHeader>
      <PanelContent>
        <ApplicationsList
          applications={applications}
          isLoading={loading}
          refresh={() => setNonce(nonce + 1)}
        />
      </PanelContent>
    </Panel>
  );
};

const SecureApplicationsPage = withAuthRedirect(ApplicationsPage);
export { SecureApplicationsPage as ApplicationsPage };
